export default {
  "content": "<path fill=\"#DDD\" fill-rule=\"evenodd\" d=\"M14.999 11.5c0 1.66-1.34 3-3 3s-3-1.34-3-3v-6c0-1.66 1.34-3 3-3s3 1.34 3 3v6zm1.93.85c.08-.49.49-.85.98-.85.61 0 1.1.54 1 1.14-.49 3-2.89 5.35-5.91 5.78v2.08c0 .55-.45 1-1 1s-1-.45-1-1v-2.08a6.993 6.993 0 01-5.91-5.78c-.09-.6.39-1.14 1-1.14.49 0 .9.36.98.85.41 2.35 2.46 4.15 4.93 4.15 2.47 0 4.52-1.8 4.93-4.15z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24"
  }
};